import qs from "query-string";
import { useCallback } from "react";

import useService from "../../../../../hooks/useService";
import { getModalHandler } from "../../../Common/Modals/hooks/useModalSingleton";
import { resolveStaticLabel } from "../helper/functions";

export function useStaticData(field = {}) {
  const { url, queryParams, fetchStaticLabel = true } = field;
  const enumRepository = useService("repositories/enum-repository");
  const { openFailureModal } = getModalHandler();

  const fetchDataValue = useCallback(
    async (value, customParams = {}) => {
      try {
        if (!url) {
          return value;
        }
        const allQueryParams = {...customParams, ...queryParams};
        const urlWithParams = `${url}?${qs.stringify(allQueryParams || {})}`;
        const response = await enumRepository.query({ urlPath: urlWithParams });
        if(fetchStaticLabel){
          return resolveStaticLabel(response, value, field);
        }
        return response;
      } catch (error) {
        console.error(error);
        openFailureModal(error);
      }
    },
    [url, queryParams, enumRepository, openFailureModal, field]
  );

  return { fetchDataValue };
}
